export default __webpack_public_path__ + "static/media/car7.fa94c18a.png";